<template>
  <div class="course-card">
    <div
      style="display: flex; justify-content: space-between; align-items: flex-start"
    >
      <div>
        <div class="course-information">
          <div>
            <div class="tdesk-secondary info-item">
              <strong class="tdesk-neutral-ultradark">{{ unitCode }}</strong>
              {{ unitDescriptor }}
            </div>

            <div v-if="unitSubheading" class="tdesk-secondary-active info-item">
              {{ unitSubheading }}
            </div>

            <div class="tdesk-secondary-active info-item">
              {{ suburb }},
              {{ state }}
            </div>

            <div class="tdesk-secondary-active info-item">
              {{ startDatetime }} ({{ timezoneAbbreviation }})
            </div>
          </div>
          <div v-if="!skipPayment" class="fee tdesk-neutral-ultradark">
            <strong>${{ fee }}</strong>
          </div>
        </div>

        <div
          v-if="!moreDetails"
          class="course-detail-trigger"
          @click="showMoreDetails()"
        >
          More details
          <i class="fas fa-sort-down" style="vertical-align: top" />
        </div>
        <div v-else class="course-detail-trigger" @click="moreDetails = false">
          Less details
          <i class="fas fa-sort-up" style="vertical-align: sub" />
        </div>
      </div>
      <div
        v-tooltip:top="placesRemaining === 0 ? 'No places remaining' : null"
        tabindex="0"
        style="position: relative; display: inline-block; width: auto"
        data-toggle="tooltip"
        class="tdesk-tooltip"
      >
        <div
          v-if="placesRemaining === 0"
          style="position:absolute;height: 100%;width:100%; cursor:not-allowed"
        />
        <button
          class="tdesk-primary-button large pull-right"
          style="margin-left: 7px"
          :disabled="placesRemaining === 0"
          @click="selectCourse()"
        >
          <i class="fas fa-chevron-circle-right" />
          Select
        </button>
      </div>
    </div>
    <div class="detail-container">
      <course-details
        v-if="moreDetails"
        :location="details.location"
        :venue-name="details.venue_name"
        :sessions="details.sessions"
        :unit-descriptor="unitDescriptor"
        :timezone-abbreviation="details.timezone_abbreviation"
        :unit-code="unitCode"
      />
      <div v-if="unitConstituentsInfo && unitConstituentsInfo.length" class="notice delivery_mode">
        <i class="fas fa-graduation-cap" />
        <div>
          <span>The following additional units will also be awarded:</span>
          <div v-for="constituent in unitConstituentsInfo" :key="constituent.code">
            <span>{{ constituent.code }} - {{ constituent.descriptor }}</span>
          </div>
        </div>
      </div>
      <div class="notice delivery_mode">
        <i class="fas fa-cog" />
        <div>
          <strong>{{ deliveryMode.friendly }}</strong>
          {{ deliveryModeDescription }}
        </div>
      </div>
      <div v-if="placesRemaining < 10" class="notice">
        <div v-if="placesRemaining === 0" class="tdesk-fail-ultradark">
          <i
            class="fas fa-user-times"
            style="font-size: 14px; margin-right: 5px;"
          />
          No places remaining
        </div>
        <div v-else class="tdesk-warn-ultradark">
          <i
            class="fas fa-exclamation-triangle"
            style="font-size: 14px; margin-right: 5px;"
          />
          {{ placesRemaining }} places remaining
        </div>
      </div>
      <div v-if="sessions > 1" class="notice">
        <div>
          <i
            class="fas fa-calendar-alt"
            style="font-size: 14px; margin-right: 5px;"
          />
          This is a
          <strong>{{ sessions }} session</strong>
          course
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import CourseDetails from './course_details';

  export default {
    components: {CourseDetails},
    props: {
      startDatetime: {
        type: String,
        required: true,
      },
      deliveryMode: {
        type: Object,
        required: true,
      },
      fee: {
        type: String,
        required: true,
      },
      sessions: {
        type: Number,
        required: true,
      },
      isIframe: {
        type: Boolean,
        required: false,
      },
      isFullWidth: {
        type: Boolean,
        required: false,
      },
      id: {
        type: String,
        required: true,
      },
      unitCode: {
        type: String,
        required: true,
      },
      unitDescriptor: {
        type: String,
        required: true,
      },
      unitSubheading: {
        type: String,
        required: false,
        default: null,
      },
      unitConstituentsInfo: {
        type: String,
        required: false,
        default: null,
      },
      suburb: {
        type: String,
        required: true,
      },
      state: {
        type: String,
        required: true,
      },
      placesRemaining: {
        type: Number,
        required: true,
      },
      timezone: {
        type: String,
        required: true,
      },
      skipPayment: {
        type: Boolean,
        required: true,
      },
      timezoneAbbreviation: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        moreDetails: false,
        details: null,
      };
    },
    computed: {
      deliveryModeDescription() {
        let deliveryMode = this.deliveryMode.actual;

        const descriptions = {
          refresher: 'This delivery mode is only for those who hold the current certificate (or less than 3 months after renewal date)',
          blended: 'Some components of the training are delivered as pre-course work prior to a face to face training and assessment session.',
          face_to_face: 'All training and assessment is delivered during the face to face training',
          blended_refresher: 'This course involves pre-course work for those who do not hold the certificate.',
          online_face_to_face: 'All learning and theory assessment is completed online prior to attending a short face to face assessment session.',
        };

        return descriptions[deliveryMode];
      },
    },
    methods: {
      showMoreDetails() {
        if (this.details) {
          return this.moreDetails = true;
        }
        var self = this;
        axios({
          method: 'get',
          headers: {'Accept': 'application/json'},
          url: Routes.extra_course_details_self_signup_calendar_index_path() + `?id=${self.id}&timezone=${self.timezone}`,
        }).then(function (response) {
          if (response.status === 200) {
            self.details = response.data;
            self.moreDetails = true;
          }
        });
      },
      selectCourse() {
        window.top.location = Routes.new_self_signup_enrol_path({cid: this.id});
      },
    },
  };
</script>

<style scoped="true" lang="scss">
.course-information {
  .info-item {
    margin: 3px 0;
  }
}
</style>
